import { AnyEventObject } from "xstate"
import { Host_Context } from "./Host_State_Machine"

interface Guard_Params {
    context: Host_Context
    event: AnyEventObject
}

export const all_players_are_in_teams = (params: Guard_Params) => {
    const { context, event } = params
    if (!context.teams_enabled) {
        return true
    }
    // generate a map of which teams players are in:
    const player_teams: {[index: string]: string} = {}
    context.teams.map(team =>
        team.members.map(member_name => (player_teams[member_name] = team.name)),
    )
    // Find any players who aren't in a team:
    if (context.players.some(player => !player_teams[player.name])) {
        event.detail = event.detail || {}
        event.detail.error_message = 'All players must be in teams before you can start the game'
        return false
    }
    return true
}